import React from 'react'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import {
  preApprovalCategory,
  preApprovalCategoryPercentage,
} from 'ppbl/utils/constants'

export const getBannerContent = (
  approvalCategory: preApprovalCategory,
  expiryDate: string,
) => {
  const superscript = (
    <sup>
      {getLocalizedText('components.preApprovalBanner.superscriptText')}
    </sup>
  )

  const contentMap = {
    [preApprovalCategory.PREAPPROVED]: {
      title: interpolate(
        getLocalizedText('components.preApprovalBanner.pre_approved.title'),
        { superscript },
      ),
      subtitle: interpolate(
        getLocalizedText('components.preApprovalBanner.pre_approved.subtitle'),
        {
          highlightPercentage: (
            <strong>{`${preApprovalCategoryPercentage.PREAPPROVED}%+`}</strong>
          ),
        },
      ),
      badgeText: interpolate(
        getLocalizedText('components.preApprovalBanner.badgeText'),
        { percentage: preApprovalCategoryPercentage.PREAPPROVED },
      ),
    },
    [preApprovalCategory.VERY_HIGH]: {
      title: interpolate(
        getLocalizedText('components.preApprovalBanner.very_high.title'),
        { superscript },
      ),
      subtitle: interpolate(
        getLocalizedText('components.preApprovalBanner.very_high.subtitle'),
        {
          highlightPercentage: (
            <strong>{`${preApprovalCategoryPercentage.VERY_HIGH}%+`}</strong>
          ),
        },
      ),
      badgeText: interpolate(
        getLocalizedText('components.preApprovalBanner.badgeText'),
        { percentage: preApprovalCategoryPercentage.VERY_HIGH },
      ),
    },
    [preApprovalCategory.HIGH]: {
      title: interpolate(
        getLocalizedText('components.preApprovalBanner.high.title'),
        { superscript },
      ),
      subtitle: interpolate(
        getLocalizedText('components.preApprovalBanner.high.subtitle'),
        {
          highlightPercentage: (
            <strong>{`${preApprovalCategoryPercentage.HIGH}%+`}</strong>
          ),
        },
      ),
      badgeText: interpolate(
        getLocalizedText('components.preApprovalBanner.badgeText'),
        { percentage: preApprovalCategoryPercentage.HIGH },
      ),
    },
    [preApprovalCategory.LOW]: {
      title: interpolate(
        getLocalizedText('components.preApprovalBanner.low.title'),
        { superscript },
      ),
      subtitle: interpolate(
        getLocalizedText('components.preApprovalBanner.low.subtitle'),
        {
          highlightPercentage: (
            <strong>{`${preApprovalCategoryPercentage.LOW}%+`}</strong>
          ),
        },
      ),
      badgeText: interpolate(
        getLocalizedText('components.preApprovalBanner.badgeText'),
        { percentage: preApprovalCategoryPercentage.LOW },
      ),
    },
  }

  return contentMap[approvalCategory]
}

export const showBanner = () => {
  const bannerEligiblePages = ['applicationPage1']
  if (typeof window === 'undefined') {
    return false
  }

  const page = window.location.pathname.split('/').pop() || ''
  return bannerEligiblePages.includes(page)
}
